import { Box, Link } from "@amzn/awsui-components-console";
import React from 'react';

import { SUPPORT_EMAIL } from "./config";

const SupportHelpBox: React.FC = () => (
  <Box>
    <h3>Need Help?</h3>
    For questions about Mamba, contact us via{" "}
    <Link href={`mailto:${SUPPORT_EMAIL}`}>email</Link>.
  </Box>
);

export default SupportHelpBox;
